import { CheckCircle2Icon, HourglassIcon, InfoIcon } from 'lucide-react'

import { VISA_BULLETIN_ICON_TYPE_MAP, type VisaBulletinIconType } from '@/lib/queries/types'
import { cn } from '@/lib/utils'

export interface VisaBulletinStatusTextProps {
  iconType?: VisaBulletinIconType
  text?: string
  className?: string
}

export const VisaBulletinStatusText = ({
  iconType = VISA_BULLETIN_ICON_TYPE_MAP.checkMark,
  text,
  className,
}: VisaBulletinStatusTextProps) => {
  if (!iconType || !text) {
    return null
  }

  return (
    <div className={cn('flex items-center', 'text-sm font-semibold leading-6 text-primary', className)}>
      <span className={cn('min-h-6 min-w-6')}>
        {iconType === VISA_BULLETIN_ICON_TYPE_MAP.checkMark && <CheckCircle2Icon size={24} />}
        {iconType === VISA_BULLETIN_ICON_TYPE_MAP.info && <InfoIcon size={24} />}
        {iconType === VISA_BULLETIN_ICON_TYPE_MAP.hourglass && <HourglassIcon size={24} />}
      </span>
      <span className={cn('ml-1.5')}>{text}</span>
    </div>
  )
}
